import { Button, Drawer, Image, Row, Select, Space } from "antd";
import { findProgrammeStudent } from "api/services/studentReservation/studentReservation.services";
import Breadcrumbs from "components/breadcrumbs";
import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

//!COMPONENTS
import AppButton from "components/libs/button";
import Matiers from "components/matiers";

//!IMAGES
import { ReactComponent as Back } from "../../../assets/images/app/backBlack.svg";
import CalendarPicture from "../../../assets/images/app/calendar_icon.svg";
import { ReactComponent as Camera } from "../../../assets/images/app/camera.svg";
import TeacherSvg from "../../../assets/images/teacher/teacher.svg";

//!STYLES
import AppResult from "components/appResults";
import SessionsCalendarGridView from "components/classroomComponents/SessionsCalendarGridView/SessionsCalendarGridView";
import { CourseViewType } from "components/classroomComponents/types";
import Container from "components/container";
import moment from "moment";
import { setOpenCoursesHistory } from "store/app/appSlice";
import { useGetOrganismRoomsQuery, useGetRoomsQuery } from "store/services/teacher/classes.services";
import { formatDates } from "utils/formats";
import s from "./assets/calendar.module.css";
import DrawerHistorique from "./components";
import CalendarOfReservationStudent from "./components/calendarReservations";

const { Option } = Select;

const StudentCalendar = () => {
  //!HOOK
  const { user } = useSelector((state) => state.auth);
  const { openCoursesHistory } = useSelector((state) => state.app);
  const dispatch = useDispatch();

  const { data: rooms, isLoading, isError, refetch } = useGetRoomsQuery(user?._id);
  const { data: organismRooms, isLoading: loadingOrganismRooms, refetch: refetchOrganismRooms } = useGetOrganismRoomsQuery(user?._id);

  //!STATE
  const [data, setData] = useState<any>();
  const [visible, setVisible] = useState(false);
  const [openDrawerHistorique, setOpenDrawerHistorique] =
    useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);
  const [selectedAd, setSelectedAd] = useState<any | null>(null);

  const [courseView, setCourseView] = useState<CourseViewType>('list');
  const [roomsData, setRoomsData] = useState<any>();
  const [calendarData, setCalendarData] = useState<any>();
  const [filter, setFilter] = useState<any>();
  const [filteredData, setFilteredData] = useState<any[]>([]);

  //!FUNCTION
  const showDrawer = () => setVisible(true);
  const onClose = () => setVisible(false);

  const getReservation = useCallback(async () => {
    setLoading(true);
    try {
      const response = await findProgrammeStudent(user?._id);
      if (response) {
        setData(response?.data);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  }, []);

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 767);
  };
  window.addEventListener('resize', handleResize);

  useEffect(() => {
    if (calendarData) {
      setFilteredData(calendarData);
    }
  }, [calendarData]);

  useEffect(() => {
    if (isLoading || loadingOrganismRooms) return;

    const merged = [...rooms.data, ...organismRooms.data];

    const unique = merged.filter(
      (room, index, self) =>
        index === self.findIndex((r) => r._id === room._id)
    );

    setRoomsData(unique);
  }, [rooms?.data, organismRooms?.data]);

  const handleFiltering = (value: string) => {
    setFilter(value);

    if (!value) {
      setFilteredData(calendarData);
      return;
    }

    let filtered = calendarData;

    if (value === 'all') {
      setFilteredData(calendarData);
    }
    else if (value === 'particular') {
      filtered = calendarData.filter(
        (session: any) =>
          session.classeId &&
          session.classeId === "" || session.classeId === undefined || session.classeId === null
      );

      setFilteredData(filtered);
    }
    else {
      filtered = calendarData.filter(
        (session: any) =>
          session.classeId &&
          session.classeId === value
      );

      setFilteredData(filtered);
    }
  };

  useEffect(() => {
    getReservation();
  }, []);

  useEffect(() => {
    if (openCoursesHistory) {
      setOpenDrawerHistorique(true);
      setTimeout(() => {
        dispatch(setOpenCoursesHistory(false));
      }, 2000);
    }
  }, [openCoursesHistory]);

  const THREE_DAYS_IN_MS = 3 * 24 * 60 * 60 * 1000;
  const NOW_IN_MS = new Date().getTime();

  const dateTimeAfterDays = NOW_IN_MS + THREE_DAYS_IN_MS;

  return (
    <React.Fragment>
      {isMobile && user?.accountManaged !== "" && <div style={{ height: "0px", width: "100%" }}></div>}
      {!isMobile && <Breadcrumbs isCalendar />}
      <div style={{ marginTop: "1em", marginBottom: "120px" }}>
        <Container>
          {isMobile ? <div className={s.headerBox}>
            <div className={s.headerBoxTitleFull}>
              <div className={s.titleBox}>
                <div className={s.titlePictureBox}>
                  <img src={CalendarPicture} height={isMobile ? 20 : 35}></img>
                </div>
                Planning des cours
              </div>

              <div className={s.buttonBox}>
                <Button className={s.newButton} onClick={() => setOpenDrawerHistorique(true)}>
                  Mon historique
                </Button>
              </div>
            </div>

            <div className={s.headerBoxTitle} style={{ marginTop: "15px" }}>
              <Space style={{ marginLeft: "10px" }}>
                {courseView === 'calendar' && <Button
                  type={'default'}
                  onClick={() => setCourseView('list')}
                  style={{ borderRadius: '20px' }}
                >
                  Vue par liste
                </Button>}
                {courseView !== 'calendar' && <Button
                  type={'default'}
                  onClick={() => setCourseView('calendar')}
                  style={{ borderRadius: '20px' }}
                >
                  Vue calendrier
                </Button>}
              </Space>

              <Select
                value={filter}
                onChange={(value) => handleFiltering(value)}
                className="select-filter"
                placeholder={<span style={{ fontSize: "12px" }}>Filtrer</span>}
              >
                {roomsData?.map((room: any, index: number) => (
                  <Option key={index} value={room?._id}>{room?.title}</Option>
                ))}
                <Option value="particular">Mes cours particuliers</Option>
                <Option value="all">Toutes les réservations</Option>
              </Select>
            </div>
          </div> : <div className={s.headerBox}>
            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "flex-start", gap: "10px" }}>
              <div className={s.titleBox}>
                <div className={s.titlePictureBox}>
                  <img src={CalendarPicture} height={isMobile ? 20 : 35}></img>
                </div>
                Planning des cours
              </div>

              <Space style={{ marginLeft: "10px" }}>
                {courseView === 'calendar' && <Button
                  type={'default'}
                  onClick={() => setCourseView('list')}
                  style={{ borderRadius: '20px' }}
                >
                  Vue par liste
                </Button>}
                {courseView !== 'calendar' && <Button
                  type={'default'}
                  onClick={() => setCourseView('calendar')}
                  style={{ borderRadius: '20px' }}
                >
                  Vue calendrier
                </Button>}
              </Space>

              <Select
                value={filter}
                onChange={(value) => handleFiltering(value)}
                className="select-filter"
                placeholder={<span style={{ fontSize: "12px" }}>Filtrer</span>}
              >
                {roomsData?.map((room: any, index: number) => (
                  <Option key={index} value={room?._id}>{room?.title}</Option>
                ))}
                <Option value="particular">Mes cours particuliers</Option>
                <Option value="all">Toutes les réservations</Option>
              </Select>
            </div>

            <div className={s.buttonBox}>
              <Button className={s.newButton} onClick={() => setOpenDrawerHistorique(true)}>
                Mon historique
              </Button>
            </div>
          </div>}

          {courseView === 'list' ? <div className={s.calendrier}>
            <div className={s.calendar__content}>
              <CalendarOfReservationStudent setCalendarData={setCalendarData} filter={filter} />
            </div>
          </div> : filteredData?.length > 0 ? <SessionsCalendarGridView
            sessions={filteredData}
            showFilter={false}
          /> : <AppResult status={"info"} title={"Aucune séance"}></AppResult>}
        </Container>
      </div>

      <Drawer
        title={null}
        width={"70%"}
        placement="right"
        onClose={onClose}
        visible={visible}
        closeIcon={
          <Back
            style={{
              width: "35px",
            }}
          />
        }
      >
        <Row justify="center">
          <div className={s.__drawer_header}>
            <h3>Réservation confirmée</h3>
            <span>
              Le {formatDates(selectedAd?.createdAt)} à{" "}
              {moment(selectedAd?.createdAt).format("LT")}min
            </span>
            <Matiers
              className={s.matiere}
              level={selectedAd?.level[0].title}
              cours={selectedAd?.topic?.title}
            />
          </div>
        </Row>
        <Row justify="center">
          <div className={s.__drawer__card}>
            <div className={s.profile}>
              <Image preview={false} className={s.__avatar} src={TeacherSvg} />
            </div>
            <h4 className={s.name}>
              {selectedAd?.teacher?.firstname} {selectedAd?.teacher?.lastname}
            </h4>

            <div className={s.card__content}>
              <span>Le cours démarre dans :</span>
              <div className={s.countDown}>
                {" "}
                <span>01 Jour : 30 Min : 10 sec</span>
              </div>
              <a href={selectedAd?.studentLink} target="_blank">
                <AppButton className={s.__button} icon={<Camera />}>
                  Lien viseoconférence
                </AppButton>
              </a>
            </div>
          </div>
        </Row>
      </Drawer>

      <DrawerHistorique
        open={openDrawerHistorique}
        setOpen={setOpenDrawerHistorique}
      />
    </React.Fragment>
  );
};

export default StudentCalendar;
